module.exports = __webpack_public_path__ + "img/45ne.fe8d02c0.svg";